import { Component, OnInit } from '@angular/core';
import { SelectorBase } from "./selector-base.component";

import { Group, GroupStub } from "../../models/group.model";

@Component({
    selector: 'admin-group-selector',
    templateUrl: "./selector-base.component.html",
    styleUrls: ['./selector-base.component.scss'],
    standalone: false
})
export class GroupSelectorComponent extends SelectorBase<Group, GroupStub> {

    compareElements(a: Group, b: Group): number {
        if (a.displayName > b.displayName) return 1;
        if (a.displayName < b.displayName) return -1;
        return 0;
    }

    elementEqualsOutput(element: Group, output: GroupStub): boolean {
        return element.id === output.id;
    }

    elementToOutput(element: Group): GroupStub {
        let g = new GroupStub();
        g.id = element.id;
        g.displayName = element.displayName;
        return g;
    }

    getDisplay(element: Group): string {
        return element.displayName;
    }



}
